import VisitorPassView from './VisitorPassView';
export default VisitorPassView;